<template>
  <div>
    <div class="row align-items-center mb-4">
      <div class="col-sm-8">
        <h3 class="mb-0">Project and Loan Details</h3>
      </div>
      <div class="col-sm-4">
        <div class="text-right">
          <template v-if="project.status === 'Pending'">
            <base-button :disabled="!canSubmit()" large icon-right="arrow-right" modal="#projectSubmissionModal" primary>
              Submit Application
            </base-button>
          </template>
          <template v-else>
            {{ project.status }}
          </template>
        </div>
        <project-submission />
      </div>
    </div>
    <div class="card-deck mb-4">
      <project-details-card />
      <project-financials-card />
    </div>
    <project-funding origination />
    <supporting-documents />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import ProjectDetailsCard from './ProjectDetailsCard.vue'
import ProjectFinancialsCard from './ProjectFinancialsCard.vue'
import ProjectFunding from './ProjectFunding.vue'
import ProjectSubmission from './ProjectSubmission.vue'
import SupportingDocuments from './SupportingDocuments.vue'

export default {
  name: 'ProjectBorrowerDashboard',

  components: {
    ProjectDetailsCard,
    ProjectFinancialsCard,
    ProjectFunding,
    ProjectSubmission,
    SupportingDocuments
  },

  computed: {
    ...mapState({
      project: store => store.core.projects.entity
    })
  },

  methods: {
    canSubmit () {
      const { details, financials, funding } = this.project.stages

      return this.project.status === 'Pending' && details && financials && funding
    }
  }
}
</script>
